import { createQueryStore } from '@ferreri/minato-react-utils';
import { useRouter } from 'next/router';

import { getCompany } from './companies.client';

export const useCompanyIdQueryParam = () => {
  const router = useRouter();

  return router?.query?.company_id as string;
};

export const useCompany = (companyId: string) => {
  return createQueryStore({
    queryKey: ['company', companyId],
    queryFn: () => getCompany(companyId),
    enabled: !!companyId,
  });
};

export const useCurrentCompany = () => {
  const companyId = useCompanyIdQueryParam();
  return useCompany(companyId);
};
